import React from 'react';
import {
  Row,
  Col,
  Button,
} from 'react-bootstrap';
import $ from 'jquery';
import { Map, List, Set } from 'immutable';
import ElementBuilder from './elements/ElementBuilder.jsx';
import { connect } from 'react-redux';
import { refLoad } from '@/component/dict/complex/product/store';
import Alert from '../../../util/Alert.jsx';
import { REF_NAME, REF_PATH } from '@/component/dict/complex/product/Const';
import 'rc-select/assets/index.css';
import { calculateUnlinkedObject } from './elements/BaseElement.jsx';
import { getDealListWrapper } from './store/DealsWrapper';
import momentLocalizer from 'react-widgets-moment';
import moment from 'moment';
moment.locale('en');
momentLocalizer();

const momentDate = (strDate) => moment(strDate, 'DD MMM YYYY');

export const filterByBL = (product, type) => product.get(`${type}Link`, new List())
  .filter(l => l.get('billLandingQuantity')).size == product.get(`${type}Link`, new List()).size
  && product.get(`${type}Link`, new List()).size > 0;

export const filterUnlinkedAndBLFunc = (product, type) => {
  const unlinked = calculateUnlinkedObject(product);
  return !!(unlinked && unlinked.quantityMin && unlinked.quantityMin > 0)
    || !filterByBL(product, type);
};

const filterByShipment = (shipment, toProduct) => {
  const [leftShipmentFrom, leftShipmentTo] = shipment || [];

  const rightShipmentFrom = toProduct.get('shipmentFrom');
  const rightShipmentTo = toProduct.get('shipmentTo');

  // Шипменты, если установлены, должны быть в пределах 1 месяца.
  // Если он не установлен в сделке, из которой линкуем - эту фильтрацию пропускаем.
  if (leftShipmentFrom && leftShipmentTo && rightShipmentFrom && rightShipmentTo) {
    return List.of(rightShipmentFrom, rightShipmentTo).some(rs => {
      const rightShipment = momentDate(rs).toDate();
      return (rightShipment >= momentDate(leftShipmentFrom).add(-1, 'M').toDate()
        && rightShipment <= momentDate(leftShipmentFrom).add(1, 'M').toDate())
        || (rightShipment >= momentDate(leftShipmentTo).add(-1, 'M').toDate()
        && rightShipment <= momentDate(leftShipmentTo).add(1, 'M').toDate());
    });
  }
  // Если шимпент не установлен - такая сделка должна показываться
  return true;
};

export const filterUnlinkedZero = (product) => {
  const unlinked = calculateUnlinkedObject(product);
  return !!(unlinked && unlinked.quantityMax && unlinked.quantityMax > 0);
};

export const filterUnlinked3000 = (product) => {
  const unlinked = calculateUnlinkedObject(product);
  return !!(unlinked && unlinked.quantityMin && unlinked.quantityMin >= 1);
};

export function filterByProductIds(productIds, data) {
  if (productIds) {
    let atoms = new List();
    if (!productIds.size) {
      return atoms;
    }
    const productIdsJS = productIds.toJS();
    data.forEach((objectToCheck) => {
      let deal = objectToCheck;
      const products = deal.get('products');
      const filteredProducts =
        products.filter(product => productIdsJS.includes(product.get('id')));
      if (filteredProducts.size !== 0) {
        deal = deal
          .delete('products')
          .set('products', filteredProducts);
        atoms = atoms.push(deal);
      }
    });
    return atoms;
  }
  return data;
}


export function filterProductsIgnoreUnlinked(usedFilters, data, type, additionalFilter = true) {
  if (usedFilters) {
    usedFilters.forEach((valueToFind, propToFind) => {
      if (valueToFind && propToFind === 'product') {
        if (valueToFind.size !== 0) {
          let atoms = new List();
          data.forEach((objectToCheck) => {
            let deal = objectToCheck;

            if (deal.get('isArchived') || deal.get('dealCanceled')) {
              return;
            }
            const products = deal.get('products');
            const filter = Set.of(valueToFind);
            const filteredProducts = products.filter(product =>
              filter.has(product.get('product')));
            if (filteredProducts.size !== 0) {
              deal = deal
                .delete('products')
                .set('products', filteredProducts);
              atoms = atoms.push(deal);
            }
          });
          // eslint-disable-next-line
          data = atoms;
        }
      } else if (valueToFind && propToFind === 'shipment' && additionalFilter) {
        let atoms = new List();
        data.forEach((objectToCheck) => {
          let deal = objectToCheck;
          const products = deal.get('products');
          const filteredProducts =
            products.filter(product => filterByShipment(valueToFind, product));
          if (filteredProducts.size !== 0) {
            deal = deal
              .delete('products')
              .set('products', filteredProducts);
            atoms = atoms.push(deal);
          }
        });
        // eslint-disable-next-line
        data = atoms;
      }
    });
  }
  return filterByProductIds(usedFilters.get('productIds'), data);
}

export function filterProducts(usedFilters, data, type, additionalFilter = true) {
  const filteredData = filterProductsIgnoreUnlinked(usedFilters, data, type, additionalFilter);
  return filteredData.filter((elem) => {
    if (!(elem.has('hidden') && elem.get('hidden'))) {
      if (!elem.get('products') || elem.get('products').size == 0) {
        return true;
      }
      return additionalFilter ? elem.get('products')
        .filter(product => filterUnlinked3000(product)
          && filterUnlinkedAndBLFunc(product, type)).size > 0
        :
        elem.get('products')
          .filter(product => filterUnlinkedZero(product)).size > 0;
    }
    return false;
  });
}

class Atoms extends React.Component {
  constructor(props) {
    super(props);
    this.filterData = this.filterData.bind(this);
    this.resize = this.resize.bind(this);
    this.hideAlert = this.hideAlert.bind(this);
    this.state = {
      originalData: undefined,
      data: undefined,
      oddData: [],
      alertMsg: undefined,
      showAlert: false,
      showOdd: false,
    };
  }
  componentWillMount() {
    if (this.props.data) {
      if (this.props.showLinks) {
        this.filterLinksData(this.props, true);
      } else {
        this.filterData(this.props, true);
      }
    }
    getDealListWrapper(this.props.dealTo);
  }
  componentDidMount() {
    this.topOffset = $('.atoms-list').offset().top;
    window.addEventListener('resize', this.resize);
  }
  componentWillReceiveProps(props) {
    getDealListWrapper(props.dealTo);
    if (props.showLinks) {
      this.filterLinksData(props);
    } else {
      this.filterData(props);
    }
    this.resize(false);
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.resize);
  }

  getDataToDisplay(data, type, initialIdx = 0, withLinks = false) {
    return data.map((elem, id) => (
      <Row key={initialIdx + id}>
        <Col
          // eslint-disable-next-line
          mdOffset={this.props.parentAtom ? (type == 'purchase' ? 0 : 6) : 0}
          md={this.props.parentAtom ? 6 : 12}
        >
          <ElementBuilder
            dealIdx={initialIdx + id}
            key={`atom-${initialIdx + id}`}
            data={elem}
            type={`connect${type}`}
            withLinks={withLinks}
            mode={this.props.selectMode || 'checkbox'}
            alerts={this.props.alerts}
            handleSelected={this.props.handleSelected}
            captionAddon={this.props.captionAddon}
            footerAddon={this.props.footerAddon}
          />
        </Col>
      </Row>
    )).toArray();
  }

  resize(withUpdate = true) {
    $('.atoms-list').css('height',
      $(window).height() - $('.atoms-list').offset().top + $(window).scrollTop());
    if (withUpdate) {
      this.forceUpdate();
    }
  }

  filterLinksData(props) {
    if (props.filterBy && !props.filterBy.get('product')) {
      this.setState({ showAlert: true, alertMsg: 'Product is not defined!' });
      return;
    }
    const originalData = props.data ? props.data : new List();
    const usedFilters = props.filterBy ? props.filterBy : undefined;
    let data = filterProductsIgnoreUnlinked(usedFilters, originalData, props.dealTo, false);
    const filterFullLinks = (elem) =>
      elem.set('products', elem.get('products').map(prod => prod.set(`${this.props.dealTo}Link`,
        prod.get(`${this.props.dealTo}Link`)
          .map(l => l.set('hide',
            l.get(`${this.props.dealFrom}Id`) && l.get(`${this.props.dealTo}Id`)))
      )));
    data = data.map(elem => filterFullLinks(elem));
    const total = data.reduce((t, d) => t + d.getIn(['products', `${this.props.dealTo}Link`],
      new Map()).size, 0);
    this.setState({
      originalData: data,
      data: this.getDataToDisplay(data, props.dealTo, 0, true),
      total,
    });
  }

  filterData(props, init = false) {
    if (props.filterBy && !props.filterBy.get('product')) {
      this.setState({ showAlert: true, alertMsg: 'Product is not defined!' });
      return;
    }
    const originalData = props.data ? props.data : new List();
    const usedFilters = props.filterBy ? props.filterBy : undefined;
    const data = filterProducts(usedFilters, originalData, props.dealTo);

    const filteredIds = data.map(elem => elem.get('id')).toJS();
    const oddData = filterProducts(usedFilters, originalData, props.dealTo, false)
      .filter(elem => !filteredIds.includes(elem.get('id')));
    if (props.data &&
        props.data.size !== 0 &&
        data.size === 0 && oddData.size === 0 && !this.props.noEmptyValidattion) {
      this.setState({ showAlert: true, alertMsg: `No records for ${props.dealTo}s!` });
    } else if (init || props.data != this.props.data || props.filterBy != this.props.filterBy) {
      this.setState({
        originalData: data,
        data: this.getDataToDisplay(data, props.dealTo),
        oddData: this.getDataToDisplay(oddData, props.dealTo, data.size),
        total: data.size,
      });
    }
  }

  hideAlert() {
    this.setState({ showAlert: false, alertMsg: '' });
    this.props.handleStepBack();
  }

  render() {
    return (
      <div className="deals">
        <Alert
          show={this.state.showAlert} message={this.state.alertMsg} hideAlert={this.hideAlert}
        />
        <div
          style={this.props.mode === 'connect' ? {} : { overflow: 'auto' }} className={'atoms-list'}
        >
          <Col md={12} className="deals-container">
            <Row>
              {this.props.dealTo == 'sale' ?
                <Col
                  md={4}
                  style={{ paddingRight: 20 }}
                  className={this.props.parentAtom ? '' : 'hidden'}
                >
                  {this.props.parentAtom}
                </Col>
                : ''}
              <Col md={this.props.parentAtom ? 8 : 12}>
                {this.state.data ?
                  this.state.data
                  : <span />}
                {this.state.showOdd && this.state.oddData ?
                  this.state.oddData
                  : <span />}
              </Col>
              {this.props.dealTo == 'purchase' ?
                <Col md={4} style={{ paddingRight: 20 }}>
                  {this.props.parentAtom}
                </Col>
                : ''}
            </Row>
            {this.state.oddData.length && !this.state.showOdd ?
              <Row>
                <Col
                  mdOffset={this.props.dealTo == 'purchase' ? 0 : 6} md={6}
                  style={{ paddingTop: '10px', textAlign: 'center' }}
                >
                  <Button
                    bsStyle={'primary'}
                    onClick={() => this.setState({ showOdd: true })}
                  >Show more</Button>
                </Col>
              </Row>
              :
              ''
            }
          </Col>
        </div>
      </div>
    );
  }
}

export default connect(
  (store, props) => ({
    selectedAtoms: store.getIn(['links', 'atoms', 'selected'], new Map()),
    filter: store.getIn(['data', 'deals', 'list', 'filters', props.dealTo]),
    data: store.getIn(['data', 'deals', 'list', props.dealTo]),
  })
  , dispatch => ({
    loadProducts() {
      refLoad(dispatch, REF_NAME, REF_PATH);
    },
  }))(Atoms);

Atoms.propTypes = {
  dealTo: React.PropTypes.string.isRequired,
  dealFrom: React.PropTypes.string,
  loadProducts: React.PropTypes.func.isRequired,
  data: React.PropTypes.object,
  filterBy: React.PropTypes.object,
  handleSelected: React.PropTypes.func,
  handleStepBack: React.PropTypes.func,
  alerts: React.PropTypes.object,
  parentAtom: React.PropTypes.object,
  selectMode: React.PropTypes.string,
  mode: React.PropTypes.string,
  noEmptyValidattion: React.PropTypes.bool,
  captionAddon: React.PropTypes.func,
  footerAddon: React.PropTypes.func,
  showLinks: React.PropTypes.bool,
};
